import { language } from "./index";

import englishLang from "assets/images/us.png";
import portugueseLang from "assets/images/br.png";
import spanishLang from "assets/images/es.png";

const config = {
  defaultLanguage: language,
  options: [
    {
      languageId: "english",
      locale: "en",
      text: "English",
      icon: englishLang
    },
    {
      languageId: "portuguese",
      locale: "pt",
      text: "Português",
      icon: portugueseLang
    },
    {
      languageId: "spanish",
      locale: "es",
      text: "Español",
      icon: spanishLang
    }
  ]
};

export function getCurrentLanguage(lang) {
  let selecetedLanguage = config.options[0];
  config.options.forEach(language => {
    if (language.languageId === lang) {
      selecetedLanguage = language;
    }
  });
  return selecetedLanguage;
}
export default config;
